import { reactive, ref, type Ref } from "vue";
import { useIntl } from "@services/i18n";
import { useApi } from "@api/integration";
import type { CreateTicket } from "@/.shared/components/soporte/models/CreateTicket";
import type { TipoTicketEnum } from "@api/api";

export function useTicketFormTipoSubtipo(model: Ref<CreateTicket | undefined>) {
  const api = useApi();
  const intl = useIntl();
  const selectTipoOptions = reactive<any>({ showClearButton: false, valueExpr: "Denominacion" });
  const selectSubtipoOptions = reactive<any>({ showClearButton: false, valueExpr: "Denominacion" });
  const mostrarCampoSubtipo = ref(false);

  async function actualizarSubtiposParaTipo(tipo: TipoTicketEnum | null | undefined) {
    if (!tipo) {
      mostrarCampoSubtipo.value = false;
      selectSubtipoOptions.dataSource = [];
      return;
    }
    const subtipos = await api.callStandardApi("getSubtiposTicketSelectorByIdTipo", { showLoading: false }, tipo);
    selectSubtipoOptions.dataSource = subtipos.map((subtipo: any) => ({
      ...subtipo,
      translatedText: intl.i18n.t(`ticket.subtipo.${subtipo.Denominacion}`)
    }));
    mostrarCampoSubtipo.value = subtipos.length > 0;
    if (subtipos.length === 0 && model.value) {
      model.value.Subtipo = null;
    }
  }

  async function cargarTiposSelector() {
    const tipos = await api.callStandardApi("getTiposTicketSelector", { showLoading: false });
    selectTipoOptions.dataSource = tipos.map((tipo: any) => ({
      ...tipo,
      translatedText: intl.i18n.t(`ticket.tipo.${tipo.Denominacion}`)
    }));
  }

  return {
    selectTipoOptions,
    selectSubtipoOptions,
    mostrarCampoSubtipo,
    actualizarSubtiposParaTipo,
    cargarTiposSelector
  };
}
